/**
 * "There is a new version" — an offer, not a reload.
 *
 * Someone assembling a slate on a boat has unsaved intent in the builder. The
 * new build can wait until they say so.
 */

interface UpdateBannerProps {
  onApply: () => void;
  onDismiss: () => void;
}

export function UpdateBanner({ onApply, onDismiss }: UpdateBannerProps) {
  return (
    <div
      role="status"
      className="no-print fixed inset-x-3 bottom-3 z-50 mx-auto flex max-w-[520px] flex-wrap items-center justify-between gap-2.5 rounded-[2px] border-2 border-graphite bg-paper px-3.5 py-2.5 shadow-lg"
    >
      <p className="m-0 text-[13px]">
        <strong className="font-semibold">A new version is ready.</strong> It will load next time
        you open the app, or now if you like.
      </p>
      <div className="flex gap-[7px]">
        <button
          type="button"
          onClick={onDismiss}
          className="cursor-pointer rounded-[2px] border-[1.5px] border-graphite bg-transparent px-3 py-1 font-display text-[14px] font-semibold uppercase tracking-[0.06em] text-graphite"
        >
          Later
        </button>
        <button
          type="button"
          onClick={onApply}
          className="cursor-pointer rounded-[2px] border-none bg-deep px-3 py-1 font-display text-[14px] font-semibold uppercase tracking-[0.06em] text-paper"
        >
          Reload
        </button>
      </div>
    </div>
  );
}
